export default __webpack_public_path__ + "static/media/03__o_3.33a6d4e3.jpg";